import InputTypes from '../../../core/enums/InputTypes';

export const inputsAnaliseNegocial = [
    {
        name: 'orgao',
        label: 'Órgão',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'proposta.orgao.descOrgao' },
        filter: { use: true, nameUse: 'proposta.orgao.idenOrgao' },
        export: { use: true, nameUse: 'proposta.orgao.descOrgao' },
        form: { use: false },
    },
    {
        name: 'numrVersao',
        label: 'Versão',
        type: InputTypes.DOUBLE,
        table: { use: true, nameUse: 'proposta.numrVersao' },
        export: { use: true, nameUse: 'proposta.numrVersao' },
    },
    {
        name: 'tipoProposta',
        label: 'Tipo de Proposta',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'proposta.tipoProposta.descTipoProposta' },
        export: { use: true, nameUse: 'proposta.tipoProposta.descTipoProposta' },
    },
    {
        name: 'numeroProposta',
        label: 'Nº Proposta',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'proposta.id' },
        filter: { use: true, nameUse: 'proposta.id' },
        export: { use: true, nameUse: 'proposta.id' },
        form: { use: false },
    },
    {
        name: 'nomeDoIndicador',
        label: 'Nome do Indicador',
        type: InputTypes.STRING,
        table: { use: true, nameUse: 'proposta.nmIndicador' },
        filter: { use: true, nameUse: 'proposta.nmIndicador' },
        export: { use: true, nameUse: 'proposta.nmIndicador' },
        form: { use: false },
    },
    {
        name: 'respCadastro',
        label: 'Resp. Cadastro',
        type: InputTypes.STRING,
        table: { use: true, nameUse: 'contaAcessoCadastro.nome' },
        filter: { use: true, nameUse: 'contaAcessoCadastro.nome' },
        form: { use: false },
    },
    {
        name: 'responsavelAnalise',
        label: 'Analista Negocial',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'responsavelAnalise.nomePessoa' },
        filter: { use: true, nameUse: 'responsavelAnalise.idenPessoa' },
        export: { use: true, nameUse: 'responsavelAnalise.nomePessoa' },
        form: { use: false },
    },
    {
        name: 'situacaoAvaliacao',
        label: 'Situação da Análise',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'situacaoAvaliacao.descSituacaoAvaliacao' },
        filter: { use: true, nameUse: 'situacaoAvaliacao.codgSituacaoAvaliacao' },
        export: { use: true, nameUse: 'situacaoAvaliacao.descSituacaoAvaliacao' },
        form: { use: false },
    },
    {
        name: 'parecer',
        label: 'Parecer',
        type: InputTypes.BOOLEAN,
        table: { use: true },
        filter: { use: true },
        export: { use: true, fromTo: ['APTO', 'INAPTO'] },
        form: { use: false },
    },
];
